import { CircularProgress, List, ListItem, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    minWidth: '520px',
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export const CreateLevelsDialog = ({
  LevelhandleClose,
  openLevel,
  PayLevel,
  setPayLevel,
  AllGrade,
  createPayLevel,
  isLoading
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={LevelhandleClose}
      aria-labelledby="customized-dialog-title"
      open={openLevel}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={LevelhandleClose}
      >
        <div className="foundation_header">Create Level</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={PayLevel.name}
              onChange={(e) =>
                setPayLevel({ ...PayLevel, name: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Pay Grade</label>
            <select
              name="effectiveStatus"
              value={PayLevel.pay_grade_id}
              onChange={(e) =>
                setPayLevel({ ...PayLevel, pay_grade_id: e.target.value })
              }
              id=""
            >
              <option value="" hidden>
                Choose pay grade
              </option>
              {AllGrade.length > 0 &&
                AllGrade?.map((item) => (
                  <option value={item?.id} key={item.id}>
                    {item?.grade}{" "}
                  </option>
                ))}
            </select>
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={PayLevel.description}
              onChange={(e) =>
                setPayLevel({ ...PayLevel, description: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Start Date</label>
            <input
              value={PayLevel.start_date}
              onChange={(e) =>
                setPayLevel({ ...PayLevel, start_date: e.target.value })
              }
              type="date"
            />
          </div>

          <div className="Box">
            <label>Effective Status</label>
            <select
              value={PayLevel.status}
              onChange={(e) =>
                setPayLevel({ ...PayLevel, status: e.target.value })
              }
              name=""
              id=""
            >
              <option value="">Choose status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={LevelhandleClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={createPayLevel}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const EditLevelDialog = ({
  handleEditLevelClose,
  editPayLevel,
  PayLevel,
  setPayLevel,
  AllGrade,
  updateCompanyPayLevel,
  isLoading
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleEditLevelClose}
      aria-labelledby="customized-dialog-title"
      open={editPayLevel!==null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleEditLevelClose}
      >
        <div className="foundation_header">Edit Level</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={PayLevel.name}
              onChange={(e) =>
                setPayLevel({ ...PayLevel, name: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Pay Grade</label>
            <select
              name="effectiveStatus"
              value={PayLevel.pay_grade_id}
              onChange={(e) =>
                setPayLevel({ ...PayLevel, pay_grade_id: e.target.value })
              }
              id=""
            >
              <option value="" hidden>
                Choose pay grade
              </option>
              {AllGrade.length > 0 &&
                AllGrade?.map((item) => (
                  <option value={item?.id} key={item.id}>
                    {item?.grade}{" "}
                  </option>
                ))}
            </select>
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={PayLevel.description}
              onChange={(e) =>
                setPayLevel({ ...PayLevel, description: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Start Date</label>
            <input
              value={PayLevel.start_date}
              onChange={(e) =>
                setPayLevel({ ...PayLevel, start_date: e.target.value })
              }
              type="date"
            />
          </div>

          <div className="Box">
            <label>Effective Status</label>
            <select
              value={PayLevel.status}
              onChange={(e) =>
                setPayLevel({ ...PayLevel, status: e.target.value })
              }
              name=""
              id=""
            >
              <option value="">Choose status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleEditLevelClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={updateCompanyPayLevel}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const DeleteLevelDialog = ({
  handleDeletePayLevelClose,
  deletePayLevel,
  deleteCompanyLevel,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleDeletePayLevelClose}
      aria-labelledby="customized-dialog-title"
      open={deletePayLevel !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleDeletePayLevelClose}
      >
        <div className="foundation_header">Delete Level</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Confirmation">Are you sure?</div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleDeletePayLevelClose} className="Btn">
            Cancel
          </button>
          <button
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
            className="Delete_Btn"
            onClick={deleteCompanyLevel}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const ViewLevelDialog = ({
  handleViewLevelClose,
  LevelViewopen,
  grade,
}) => {
  return (
    <BootstrapDialog
      onClose={handleViewLevelClose}
      aria-labelledby="customized-dialog-title"
      open={LevelViewopen !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleViewLevelClose}
      >
        <div className="foundation_header">View Pay Level</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <List>
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Name</label>
            <p>{LevelViewopen?.level}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Pay Grade</label>
            <p>{`${grade?.grade??"Nil"}`}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Description</label>
            <p>{LevelViewopen?.description}</p>
          </ListItem>
        </List>
      </DialogContent>
    </BootstrapDialog>
  );
};
